import React from 'react';
export function SolutionSection() {
  return <section className="py-12 bg-main overflow-hidden" data-id="element-156">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-157">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-158">
          <div data-id="element-159">
            <h2 className="text-3xl md:text-5xl font-serif mb-6 leading-tight text-title" data-id="element-160">
              Gana sin ser vista.
            </h2>
            <p className="text-body text-lg mb-8 leading-relaxed" data-id="element-161">
              Las cuentas que más crecen hoy no venden una persona. Venden una
              estética + una solución.
            </p>
            <div className="p-6 bg-alt border-l-4 border-accent" data-id="element-162">
              <p className="font-serif text-lg italic text-title" data-id="element-163">
                "La era de vender tu vida privada terminó. Ahora gana quien
                tiene método."
              </p>
            </div>
          </div>

          <div className="relative" data-id="element-164">
            <div className="space-y-8" data-id="element-165">
              <div className="bg-card p-8 border border-[#E7D8C8] relative" data-id="element-166">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-167">
                  01
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-168">
                  Anonimato es poder
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-169">
                  Construyes una marca que funciona sin depender de tu imagen.
                </p>
              </div>

              <div className="bg-card p-8 border border-[#E7D8C8] relative ml-4 md:ml-8" data-id="element-170">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-171">
                  02
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-172">
                  Contenido faceless (sin complicarte)
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-173">
                  Aprendes qué tipos de videos/fotos funcionan sin mostrar
                  rostro y cómo adaptarlos a tu estilo.
                </p>
              </div>

              <div className="bg-card p-8 border border-[#E7D8C8] relative ml-8 md:ml-16" data-id="element-174">
                <span className="absolute -top-4 -left-4 w-10 h-10 bg-accent text-white flex items-center justify-center font-serif text-lg font-bold" data-id="element-175">
                  03
                </span>
                <h4 className="font-serif text-xl mb-2 text-title ml-4" data-id="element-176">
                  Estructura que convierte
                </h4>
                <p className="text-body text-sm ml-4" data-id="element-177">
                  Publicas con intención: perfil, mensajes y contenido alineados
                  para que la gente entienda y confíe.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}